import {
  type DietaryRestrictionsText,
  getDietaryIngredients,
  useCustomerDietaryRestrictions,
} from '@hungryroot/dietary-restrictions';
import { usePairing } from '../../../api/v2/pairings/[id]/get/get-pairing';

export function getWarningTextForModal(
  dietaryIngredients: DietaryRestrictionsText[]
) {
  if (dietaryIngredients.length === 1) {
    return dietaryIngredients[0];
  } else if (dietaryIngredients.length === 2) {
    return dietaryIngredients?.join(' + ');
  } else {
    return (
      dietaryIngredients?.slice(0, -1).join(', ') +
      ' + ' +
      dietaryIngredients?.slice(-1)
    );
  }
}

export const usePairingDietaryIngredients = (
  id: number,
  options?: { enabled: boolean }
) => {
  const {
    data: dietaryRestrictionsData,
    isLoading: isDietaryRestrictionsDataLoading,
  } = useCustomerDietaryRestrictions();
  const { data, isLoading: isPairingLoading } = usePairing(id, options);

  const isLoading = isDietaryRestrictionsDataLoading || isPairingLoading;

  if (!data || !dietaryRestrictionsData || isLoading) {
    return {
      data: [],
      isLoading,
    };
  }

  return {
    data: getDietaryIngredients(
      data?.tags,
      dietaryRestrictionsData?.dietary_restrictions
    ),
    isLoading,
  };
};
